import { ensure } from "sprint-common-web";

import { ContentSubtype } from "../../../../../../common/types/ContentSubtype";
import { LookupContentItem } from "../../../../lookup-content/LookupContentItem";
import { useSetLookupContent } from "../hooks/useSetLookupContent";

export const useAssociateLookupContent = () => {
    const { setMovieContent, setTvContent, setAncillaryContent } = useSetLookupContent();

    const setContentFromLookupContent = (item: LookupContentItem) => {
        ensure(item.subtype);
        switch (item.subtype) {
            case ContentSubtype.Movie:
            case ContentSubtype.TvSingle:
            case ContentSubtype.FeatureDocumentary:
            case ContentSubtype.ShortFilm: {
                setMovieContent(item.movie.id, [item.version.id]);

                break;
            }

            case ContentSubtype.TV: {
                setTvContent({
                    tvSeriesId: item.tvSeries.id,
                    seasonId: item.season.id,
                    episodeId: item.episode.id,
                    versionIds: [item.version.id]
                });

                break;
            }

            case ContentSubtype.Promo:
            case ContentSubtype.Advert:
            case ContentSubtype.Safety:
            case ContentSubtype.ClientSpecific:
            case ContentSubtype.IndentWarning: {
                setAncillaryContent(item.ancillary.id, item.version.airlines[0]);

                break;
            }
        }
    };

    return { setContentFromLookupContent };
};
